var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 40,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _vm._t("text-title"),
          ],
          2
        ),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [_vm._t("text-content")],
        2
      ),
      _c(
        "footer",
        {
          staticClass: "modal-card-foot",
          style: `justify-content: flex-${_vm.buttonLocation}`,
        },
        [
          _c(
            "button",
            {
              staticClass: "button is-success tooltip",
              attrs: {
                "data-tooltip": "Previous step",
                disabled: _vm.previousDisabled,
              },
              on: {
                click: function ($event) {
                  return _vm.previous()
                },
              },
            },
            [_vm._v("Previous")]
          ),
          !_vm.nextDisabled
            ? _c(
                "button",
                {
                  staticClass: "button is-warning tooltip",
                  attrs: {
                    "data-tooltip": "Next step",
                    disabled: _vm.nextDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.next()
                    },
                  },
                },
                [_vm._v("Next")]
              )
            : _vm._e(),
          !_vm.continueDisabled
            ? _c(
                "button",
                {
                  staticClass: "button is-primary tooltip",
                  attrs: { "data-tooltip": "Continue" },
                  on: {
                    click: function ($event) {
                      return _vm.load()
                    },
                  },
                },
                [_vm._v("Continue")]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "button tooltip",
              attrs: { "data-tooltip": "Don't continue" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("Close")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }